import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "opportunity-form",
  class: "salesforce-opportunity-form"
}
const _hoisted_2 = { class: "form-toolbar" }
const _hoisted_3 = { class: "form-cards-container" }
const _hoisted_4 = { class: "card-grid" }
const _hoisted_5 = { class: "field-group" }
const _hoisted_6 = { class: "field-group" }
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-group" }
const _hoisted_11 = { class: "field-group field-full" }
const _hoisted_12 = { class: "field-group field-full" }
const _hoisted_13 = { class: "card-grid" }
const _hoisted_14 = { class: "field-group" }
const _hoisted_15 = { class: "field-group" }
const _hoisted_16 = { class: "field-group" }
const _hoisted_17 = { class: "field-group" }
const _hoisted_18 = { class: "field-group" }
const _hoisted_19 = { class: "field-group" }
const _hoisted_20 = { class: "field-group" }
const _hoisted_21 = { class: "field-group" }
const _hoisted_22 = { class: "field-group field-full" }
const _hoisted_23 = { class: "card-grid" }
const _hoisted_24 = { class: "field-group" }
const _hoisted_25 = { class: "field-group" }
const _hoisted_26 = { class: "field-group" }
const _hoisted_27 = { class: "field-group" }
const _hoisted_28 = { class: "field-group" }
const _hoisted_29 = { class: "field-group" }
const _hoisted_30 = { class: "field-group" }
const _hoisted_31 = { class: "field-group" }
const _hoisted_32 = { class: "field-group field-full" }
const _hoisted_33 = { class: "card-grid" }
const _hoisted_34 = { class: "field-group" }
const _hoisted_35 = { class: "field-group" }
const _hoisted_36 = { class: "field-group" }
const _hoisted_37 = { class: "field-group" }
const _hoisted_38 = { class: "field-group" }
const _hoisted_39 = { class: "field-group" }
const _hoisted_40 = { class: "field-group" }
const _hoisted_41 = { class: "field-group" }
const _hoisted_42 = { class: "field-group" }
const _hoisted_43 = { class: "card-grid" }
const _hoisted_44 = { class: "field-group" }
const _hoisted_45 = { class: "field-group" }
const _hoisted_46 = { class: "field-group" }
const _hoisted_47 = { class: "field-group" }
const _hoisted_48 = { class: "field-group field-full" }
const _hoisted_49 = { class: "card-grid" }
const _hoisted_50 = { class: "field-group" }
const _hoisted_51 = { class: "field-group" }
const _hoisted_52 = { class: "field-group" }
const _hoisted_53 = { class: "field-group" }
const _hoisted_54 = { class: "field-group" }
const _hoisted_55 = { class: "field-group" }
const _hoisted_56 = { class: "field-group" }
const _hoisted_57 = { class: "field-group" }
const _hoisted_58 = { class: "field-group" }
const _hoisted_59 = { class: "field-group" }
const _hoisted_60 = { class: "field-group" }
const _hoisted_61 = { class: "field-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarForm = _resolveComponent("ToolbarForm")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_FormTextbox = _resolveComponent("FormTextbox")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidator = _resolveComponent("DxValidator")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxValidationGroup = _resolveComponent("DxValidationGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxValidationGroup, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ToolbarForm, {
            "is-editing": _ctx.isEditing,
            onEditCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
            onEditToggled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEdit())),
            onSaveClicked: _ctx.handleSaveClick
          }, null, 8, ["is-editing", "onSaveClicked"])
        ]),
        _createVNode(_component_DxLoadPanel, {
          "show-pane": false,
          width: "auto",
          container: "#opportunity-form",
          position: { of: '#opportunity-form' }
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.identitate }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSection('identitate')))
            }, [
              _cache[66] || (_cache[66] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
              _cache[67] || (_cache[67] = _createElementVNode("h3", null, "Identitate & Fiscal", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.identitate ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[68] || (_cache[68] = _createElementVNode("label", { class: "field-label" }, "Nume", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Nume,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.partenerData.Nume) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.defaultValidators as any)
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[69] || (_cache[69] = _createElementVNode("label", { class: "field-label" }, "CUI", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CUI,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.partenerData.CUI) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: (_ctx.defaultValidators as any),
                  buttons: _ctx.cuiButtons
                }, null, 8, ["modelValue", "is-editing", "validators", "buttons"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[70] || (_cache[70] = _createElementVNode("label", { class: "field-label" }, "Tip Fiscal", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.partenerData.Fiscal,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.partenerData.Fiscal) = $event)),
                  "data-source": _ctx.dsParteneriFiscal,
                  "display-expr": "Nume",
                  "value-expr": "Cod",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isParteneriFiscaliGridBoxOpened,
                  "onUpdate:opened": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isParteneriFiscaliGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsParteneriFiscal,
                      columns: ['Nume'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedPartenerFiscal
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută tip fiscal..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidator, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Tipul Fiscal este obligatoriu" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[71] || (_cache[71] = _createElementVNode("label", { class: "field-label" }, "Cod Caen", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Caen,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.partenerData.Caen) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[72] || (_cache[72] = _createElementVNode("label", { class: "field-label" }, "Nr. Reg. Com", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Numar,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.partenerData.Numar) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[73] || (_cache[73] = _createElementVNode("label", { class: "field-label" }, "Responsabil", -1)),
                (_ctx.isEditing)
                  ? (_openBlock(), _createBlock(_component_DxSelectBox, {
                      key: 0,
                      modelValue: _ctx.partenerData.Owner,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.partenerData.Owner) = $event)),
                      "data-source": _ctx.dsUsers,
                      "display-expr": "Username",
                      "value-expr": "Username",
                      "show-clear-button": true,
                      "search-enabled": true
                    }, null, 8, ["modelValue", "data-source"]))
                  : (_openBlock(), _createBlock(_component_FormTextbox, {
                      key: 1,
                      modelValue: _ctx.partenerData.Owner,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.partenerData.Owner) = $event)),
                      "is-editing": false,
                      "show-label": false
                    }, null, 8, ["modelValue"]))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[74] || (_cache[74] = _createElementVNode("label", { class: "field-label" }, "Cont (IBAN)", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Cont,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.partenerData.Cont) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[75] || (_cache[75] = _createElementVNode("label", { class: "field-label" }, "Memo", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Memo,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.partenerData.Memo) = $event)),
                  "is-editing": _ctx.isEditing,
                  "show-label": false,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.identitate]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.social }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleSection('social')))
            }, [
              _cache[76] || (_cache[76] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[77] || (_cache[77] = _createElementVNode("h3", null, "Sediu Social", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.social ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[78] || (_cache[78] = _createElementVNode("label", { class: "field-label" }, "Strada", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Strada,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.partenerData.Strada) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[79] || (_cache[79] = _createElementVNode("label", { class: "field-label" }, "Nr.", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Numarstrada,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.partenerData.Numarstrada) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[80] || (_cache[80] = _createElementVNode("label", { class: "field-label" }, "Bloc", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Bloc,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.partenerData.Bloc) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[81] || (_cache[81] = _createElementVNode("label", { class: "field-label" }, "Scara", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Scarabloc,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.partenerData.Scarabloc) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[82] || (_cache[82] = _createElementVNode("label", { class: "field-label" }, "Etaj", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Et,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.partenerData.Et) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[83] || (_cache[83] = _createElementVNode("label", { class: "field-label" }, "Ap.", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Ap,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.partenerData.Ap) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[84] || (_cache[84] = _createElementVNode("label", { class: "field-label" }, "Localitate", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Localitate,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.partenerData.Localitate) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[85] || (_cache[85] = _createElementVNode("label", { class: "field-label" }, "Cod Poștal", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CP,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.partenerData.CP) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[86] || (_cache[86] = _createElementVNode("label", { class: "field-label" }, "Adresa", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Adresa,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.partenerData.Adresa) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.social]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.DomiciliuFiscal }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleSection('DomiciliuFiscal')))
            }, [
              _cache[87] || (_cache[87] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[88] || (_cache[88] = _createElementVNode("h3", null, "Domiciliu Fiscal", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.DomiciliuFiscal ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[89] || (_cache[89] = _createElementVNode("label", { class: "field-label" }, "Strada", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CStrada,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.partenerData.CStrada) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[90] || (_cache[90] = _createElementVNode("label", { class: "field-label" }, "Nr.", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CNumarstrada,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.partenerData.CNumarstrada) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[91] || (_cache[91] = _createElementVNode("label", { class: "field-label" }, "Bloc", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CBloc,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.partenerData.CBloc) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[92] || (_cache[92] = _createElementVNode("label", { class: "field-label" }, "Scara", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CScarabloc,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.partenerData.CScarabloc) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[93] || (_cache[93] = _createElementVNode("label", { class: "field-label" }, "Etaj", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CEt,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.partenerData.CEt) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[94] || (_cache[94] = _createElementVNode("label", { class: "field-label" }, "Ap.", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CAp,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.partenerData.CAp) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[95] || (_cache[95] = _createElementVNode("label", { class: "field-label" }, "Localitate", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CLocalitate,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.partenerData.CLocalitate) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[96] || (_cache[96] = _createElementVNode("label", { class: "field-label" }, "Cod Poștal", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CCP,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.partenerData.CCP) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[97] || (_cache[97] = _createElementVNode("label", { class: "field-label" }, "Adresa", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CAdresa,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.partenerData.CAdresa) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.DomiciliuFiscal]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.financiar }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.toggleSection('financiar')))
            }, [
              _cache[98] || (_cache[98] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[99] || (_cache[99] = _createElementVNode("h3", null, "Configurare Financiară & Comericală", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.financiar ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[100] || (_cache[100] = _createElementVNode("label", { class: "field-label" }, "Banca (Internă)", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.partenerData.Banca,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.partenerData.Banca) = $event)),
                  "data-source": _ctx.dsBanci,
                  "display-expr": "Nume",
                  "value-expr": "Nume",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isBanciGridBoxOpened,
                  "onUpdate:opened": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.isBanciGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsBanci,
                      columns: ['Nume'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedBanca
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută bancă..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[101] || (_cache[101] = _createElementVNode("label", { class: "field-label" }, "Valută", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.partenerData.ValutaID,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.partenerData.ValutaID) = $event)),
                  "data-source": _ctx.dsValute,
                  "display-expr": "Simbol",
                  "value-expr": "Id",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isValuteGridBoxOpened,
                  "onUpdate:opened": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.isValuteGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsValute,
                      columns: ['Simbol'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedValuta
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută valuta..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[102] || (_cache[102] = _createElementVNode("label", { class: "field-label" }, "Capital Social", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CapitalSocial,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.partenerData.CapitalSocial) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[103] || (_cache[103] = _createElementVNode("label", { class: "field-label" }, "Cifra Afacere", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.CifraAfacere,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.partenerData.CifraAfacere) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[104] || (_cache[104] = _createElementVNode("label", { class: "field-label" }, "Nr. Angajati", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.NrAngajati,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.partenerData.NrAngajati) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[105] || (_cache[105] = _createElementVNode("label", { class: "field-label" }, "Grup", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.partenerData.GrupID,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.partenerData.GrupID) = $event)),
                  "data-source": _ctx.dsGrupuri,
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isGrupuriGridBoxOpened,
                  "onUpdate:opened": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.isGrupuriGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsGrupuri,
                      columns: ['Nume'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedGrup
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută grup..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[106] || (_cache[106] = _createElementVNode("label", { class: "field-label" }, "Zona", -1)),
                _createVNode(_component_DxDropDownBox, {
                  modelValue: _ctx.partenerData.ZonaID,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.partenerData.ZonaID) = $event)),
                  "data-source": _ctx.dsZone,
                  "display-expr": "Nume",
                  "value-expr": "Id",
                  "read-only": !_ctx.isEditing,
                  opened: _ctx.isZoneGridBoxOpened,
                  "onUpdate:opened": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.isZoneGridBoxOpened) = $event)),
                  "show-clear-button": true,
                  "drop-down-options": { width: 450 }
                }, {
                  content: _withCtx(() => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsZone,
                      columns: ['Nume'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _ctx.onValueSelectedZone
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxScrolling, { mode: "virtual" }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Caută zonă..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onSelectionChanged"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "data-source", "read-only", "opened"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[107] || (_cache[107] = _createElementVNode("label", { class: "field-label" }, "Adaos Pret", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.AdaosPret,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.partenerData.AdaosPret) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[108] || (_cache[108] = _createElementVNode("label", { class: "field-label" }, "Scadenta", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Scadenta,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.partenerData.Scadenta) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.financiar]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.contact }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleSection('contact')))
            }, [
              _cache[109] || (_cache[109] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[110] || (_cache[110] = _createElementVNode("h3", null, "Contact & Diverse", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.contact ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[111] || (_cache[111] = _createElementVNode("label", { class: "field-label" }, "Telefon", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Tel,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.partenerData.Tel) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[112] || (_cache[112] = _createElementVNode("label", { class: "field-label" }, "Fax", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Fax,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.partenerData.Fax) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[113] || (_cache[113] = _createElementVNode("label", { class: "field-label" }, "Email", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Email,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.partenerData.Email) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[114] || (_cache[114] = _createElementVNode("label", { class: "field-label" }, "Director", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Director,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.partenerData.Director) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[115] || (_cache[115] = _createElementVNode("label", { class: "field-label" }, "Observatii", -1)),
                _createVNode(_component_FormTextbox, {
                  modelValue: _ctx.partenerData.Observatii,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.partenerData.Observatii) = $event)),
                  "is-editing": _ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "is-editing", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.contact]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.systemFlags }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.toggleSection('systemFlags')))
            }, [
              _cache[116] || (_cache[116] = _createElementVNode("i", { class: "dx-icon-home" }, null, -1)),
              _cache[117] || (_cache[117] = _createElementVNode("h3", null, "System Flags", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.systemFlags ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[118] || (_cache[118] = _createElementVNode("label", { class: "field-label" }, "TVA la Încasare", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.AplicaTVAlaIncasare,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.partenerData.AplicaTVAlaIncasare) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[119] || (_cache[119] = _createElementVNode("label", { class: "field-label" }, "Regim Special TVA", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.RegimSpecialTVA,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.partenerData.RegimSpecialTVA) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _cache[120] || (_cache[120] = _createElementVNode("label", { class: "field-label" }, "Intern", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Intern,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.partenerData.Intern) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators,
                  onValueChanged: _ctx.handleInternChange
                }, null, 8, ["modelValue", "read-only", "validators", "onValueChanged"])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[121] || (_cache[121] = _createElementVNode("label", { class: "field-label" }, "Extern Non UE", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Extern,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.partenerData.Extern) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators,
                  onValueChanged: _ctx.handleExternChange
                }, null, 8, ["modelValue", "read-only", "validators", "onValueChanged"])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[122] || (_cache[122] = _createElementVNode("label", { class: "field-label" }, "Extern UE", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.ExternUE,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.partenerData.ExternUE) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators,
                  onValueChanged: _ctx.handleExternUEChange
                }, null, 8, ["modelValue", "read-only", "validators", "onValueChanged"])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[123] || (_cache[123] = _createElementVNode("label", { class: "field-label" }, "Client", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Client,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.partenerData.Client) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _cache[124] || (_cache[124] = _createElementVNode("label", { class: "field-label" }, "Furnizor", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Furnizor,
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.partenerData.Furnizor) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[125] || (_cache[125] = _createElementVNode("label", { class: "field-label" }, "Activ", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Activ,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.partenerData.Activ) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "field-label" }, "Split TVA", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.AplicaTvaDefalcat,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.partenerData.AplicaTvaDefalcat) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "field-label" }, "Fara Scadenta", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.faraScadenta,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.partenerData.faraScadenta) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[128] || (_cache[128] = _createElementVNode("label", { class: "field-label" }, "Calculez Penalitati", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.CalculezPenalitati,
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.partenerData.CalculezPenalitati) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _cache[129] || (_cache[129] = _createElementVNode("label", { class: "field-label" }, "Litigiu", -1)),
                _createVNode(_component_DxCheckBox, {
                  modelValue: _ctx.partenerData.Litigiu,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.partenerData.Litigiu) = $event)),
                  "read-only": !_ctx.isEditing,
                  validators: _ctx.optionalValidators
                }, null, 8, ["modelValue", "read-only", "validators"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.systemFlags]
            ])
          ], 2)
        ])
      ]),
      _: 1
    })
  ]))
}